import React from 'react';
import styled from 'styled-components';
import IconsBox from '@components/shared/IconsBox';
import { ZeroWasteData } from '@data/proviotics';
import Carousel from '@components/shared/Carousel';
import { PageSlice } from '@contracts';
import Colors from '@components/shared/Colors';
import useDesktop from '@components/shared/useDesktop';

interface Props {
  slice: PageSlice;
  data: ZeroWasteData;
}

const carouselOptions = {
  autoPlay: false,
  groupCells: false,
  cellAlign: 'center',
  draggable: true,
  pageDots: true
};

const ProvioticsZeroWaste: React.FC<Props> = ({ slice, data }) => {
  const isMobile = !useDesktop(1024);

  return (
    <Container>
      <IconsBoxWrap>
        {isMobile ? (
          <CarouselWrap>
            <Carousel options={carouselOptions}>
              {data.iconBoxes.map((iconBox, index) => (
                <IconsBox data={iconBox} index={index} key={index} />
              ))}
            </Carousel>
          </CarouselWrap>
        ) : (
          <>
            {data.iconBoxes.map((iconBox, index) => (
              <IconsBox data={iconBox} index={index} key={index} />
            ))}
          </>
        )}
      </IconsBoxWrap>
    </Container>
  );
};

export default ProvioticsZeroWaste;

const Container = styled.div`
  color: ${Colors.navyBlue};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to top, #ebf1f5, rgba(235, 241, 245, 0) 349px);
  padding-bottom: 50px;
  overflow: hidden;
`;

const IconsBoxWrap = styled.div`
  display: flex;
  justify-content: center;
  width: 910px;
  gap: 40px;
  overflow: hidden;

  @media only screen and (max-width: 1024px) {
    width: 100vw;
    justify-content: center;
  }
`;

const CarouselWrap = styled.div`
  width: 100%;
  padding: 0 30px;

  .flickity-viewport {
    overflow: visible;
  }
`;
